




































































































































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"
import AlertArea from "../components/AlertArea.vue";

export interface FieldActivity {
  id: number
  correct_state: number
  correct_state_cache: number | null
  score: number
  is_correct_changed: boolean
  is_correct_changed_cache: boolean
  recog_text: string
  svgContent: string
}

export interface Data {
  tabNo: number
  recogTypes: any[]
  choices: Common.ComoboxRecogChar[]
  choice_idx_from: number
  choice_idx_to: number
  correct_idx: number
  errors: string[]
  resultFields: any[]
  resultDetailFields: any[]
  resultFieldActivities: FieldActivity[]
  isTargetAll: boolean
  isDispCorrectImage: boolean
  resultAreaHeight: number
  isRecogCorrectImage: boolean
  correctSvgContent: string
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    isRecogOverlay: {
      type: Boolean,
      default: false,
    },
    fieldActivities: {
      type: Array as PropType<any[]>,
      required: true
    },
    base64CorrectImage: {
      type: String,
      default: false,
    },
    correctImageWidth: {
      type: Number,
    },
    correctImageHeight: {
      type: Number,
    },
    windowHeight: {
      type: Number
    },
    isRecogSidebarVisible: {
      type: Boolean
    },
    recog_type: {
      type: Number
    },
    recog_correct_text: {
      type: String
    },
  },
  setup (props, context) {

    /************************************************************
    * Data
    ************************************************************/

    const state = reactive<Data>({
      tabNo: 1,
      recogTypes: Common.GetComboboxRecogTypeArray(),
      choices: [],
      choice_idx_from: null,
      choice_idx_to: null,
      correct_idx: null,
      errors: [],
      resultFields: [
        {key: "recog_text", label: "認識結果", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "count", label: "件数", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "100px"}},
        {key: "saiten", label: "採点", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "120px"}},
        {key: "detail", label: "詳細", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "80px"}},
      ],
      resultDetailFields: [
        {key: "no", label: "No", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "cut_image", label: "切出し画像", sortable: false, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        {key: "recog_text", label: "認識結果", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        // {key: "confidence", label: "信頼度", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap"}},
        // {key: "saiten", label: "採点", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "120px"}},
        {key: "correct_state", label: "正誤", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "120px"}},
      ],
      resultFieldActivities: [],
      isTargetAll: false,
      isDispCorrectImage: false,
      resultAreaHeight: 0,
      isRecogCorrectImage: true,
      correctSvgContent: null,
    });

    const RecogTypeEnum = Common.RecogTypeEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;
    const SheetTypeEnum = Common.SheetTypeEnum;

    /************************************************************
      * 模範解答imgタグのCSS
      ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      // style["width"] = `${props.correctImageWidth}px`;
      // style["height"] = `${props.correctImageHeight}px`;
      style["margin-top"] = `8px`;
      style["padding-left"] = `8px`;
      style["padding-right"] = `8px`;
      style["padding-bottom"] = `8px`;
      return style;
    });

    /************************************************************
      * 認識結果エリアの高さ設定
      ************************************************************/

    const setResultAreaHeight = () => {
      let resultAreaHeight = 0;
      const tabBorder = document.getElementById("tab-border");
      const header = document.getElementsByClassName("b-sidebar-header");
      
      if(tabBorder && header.length > 0){
        resultAreaHeight = props.windowHeight - tabBorder.offsetTop - header[0].clientHeight - 16;
      }
      state.resultAreaHeight = resultAreaHeight;
    }

    watch(() => props.windowHeight, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    watch(() => state.isDispCorrectImage, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    watch(() => props.isRecogSidebarVisible, async (newVal, oldVal) => {
      context.root.$nextTick(() => {
        setResultAreaHeight();
      });
    });

    watch(() => state.isRecogCorrectImage, async (newVal, oldVal) => {
      updateCorrectSvgContent();
    });

    watch(() => state.correct_idx, async (newVal, oldVal) => {
      const recog_correct_text = state.choices[state.correct_idx].text;
      context.emit("correct-text-changed", recog_correct_text);
    });

    watch(() => props.recog_correct_text, async (newVal, oldVal) => {
      updateCorrectSvgContent();

      if(isSingleCharRecog.value){
        const choice = state.choices.find(x => x.text == newVal);
        if(choice != null){
          const idx = state.choices.indexOf(choice);
          state.correct_idx = idx != -1 ? idx : null;
        }else{
          state.correct_idx = null;
        }
      }
    });

    /************************************************************
      * 一文字認識か判定
      ************************************************************/

    const isSingleCharRecog = computed((): boolean => {
      return Common.IsSingleCharRecog(props.recog_type);
    });

    /************************************************************
      * 正答範囲の表示有無
      ************************************************************/

    const isDispFromToCharArea = computed((): boolean => {
      return [RecogTypeEnum.SingleAlpha, RecogTypeEnum.SingleHira, RecogTypeEnum.SingleKana, RecogTypeEnum.SingleNumber].includes(props.recog_type);
    });

    /************************************************************
      * 文字種別ラジオボタン変更
      ************************************************************/

    const recogTypeChanged = (recog_type: number) => {

      if(isSingleCharRecog){
        state.choices = Common.GetComboboxRecogCharArray(recog_type);
        state.choice_idx_from = null;
        state.choice_idx_to = null;
      }

      context.emit("recog-type-changed", recog_type);
      updateCorrectSvgContent();
    }

    /************************************************************
      * 正答文字列変更
      ************************************************************/

    const correctTextChanged = (recog_correct_text: string) => {
      context.emit("correct-text-changed", recog_correct_text);
      updateCorrectSvgContent();
    }

    const recogTextChanged = (field_activity_id: number, recog_text: string) => {
      context.emit("recog-text-changed", field_activity_id, recog_text);
    }

    const updateCorrectSvgContent = () => {
      context.root.$nextTick(() => {
        if(props.recog_type == RecogTypeEnum.Math && props.recog_correct_text != null){
          state.correctSvgContent = Common.convertSvgElementByLaTex(props.recog_correct_text);
        }else{
          state.correctSvgContent = null;
        }
      });
    }

    /************************************************************
      * サイドバーClose
      ************************************************************/

    const hiddenSidebar = () => {
      context.emit("hidden");
    }
    
    /************************************************************
      * 文字認識API実行
      ************************************************************/

    const recogExecute = async () => {
      
      if(props.recog_type == null){
        alert("文字種別を選択してください。");
        return;
      }

      if(!state.isRecogCorrectImage){
        if(isSingleCharRecog.value){
          if(state.correct_idx == null){
            alert("正答を選択してください");
            return;
          }
        }else if(props.recog_correct_text == null || props.recog_correct_text == ""){
          alert("正答を入力してください");
          return;
        }
      }

      if((state.choice_idx_from == null && state.choice_idx_to != null) || (state.choice_idx_from != null && state.choice_idx_to == null)){
        alert("文字範囲を指定する場合は、開始・終了両方を入力してください。");
        return;
      }
      
      let choice_idx_from = null;
      let choice_idx_to = null;

      const field_activity_ids = state.isTargetAll ? props.fieldActivities.map((x: any) => x.id) : props.fieldActivities.filter(x => x.correct_state == null).map((x: any) => x.id);

      if(!state.isTargetAll && field_activity_ids.length == 0){
        alert("全て採点済みのため文字認識対象がありません。");
        return;
      }

      if(isSingleCharRecog && state.choice_idx_from != null && state.choice_idx_to != null){
        choice_idx_from = Math.min(...[state.choice_idx_from, state.choice_idx_to]);
        choice_idx_to = Math.max(...[state.choice_idx_from, state.choice_idx_to]);
      }

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "文字認識を実行します。よろしいですか？")){
        return;
      }

      const param = {
        recog_type: props.recog_type,
        choice_idx_from: choice_idx_from,
        choice_idx_to: choice_idx_to,
        recog_correct_text: state.isRecogCorrectImage ? null : getCorrectText(),
        field_activity_ids: field_activity_ids,
        is_recog_correct_image: state.isRecogCorrectImage,
      }

      context.emit("recog-execute", param);
    }


    const recogByText = () => {

      const param = {
        recog_type: props.recog_type,
        recog_correct_text: getCorrectText(),
        param_field_activities: props.fieldActivities.map(x => {return {id: x.id, recog_text: x.recog_text}}),
      }
      context.emit("recog-by-text", param);      
    }

    const setResultFieldActivities = (field_activity_ids: number[]) => {
      state.resultFieldActivities =  props.fieldActivities.filter(x => field_activity_ids.includes(x.id)).sort((a, b) => {
        // correct_state を降順で比較
        if (a.correct_state > b.correct_state) return -1;
        if (a.correct_state < b.correct_state) return 1;
        
        // correct_state recog_text を昇順で比較
        if (a.recog_text < b.recog_text) return -1;
        if (a.recog_text > b.recog_text) return 1;
        
        return 0; // 全部同じだったらそのまま
      });
    }

    const getCorrectText = () => {
      let rtn = null;
      if(isSingleCharRecog.value){
        rtn = state.choices[state.correct_idx].text;
      }else if(props.recog_correct_text != null && props.recog_correct_text != ""){
        rtn = props.recog_correct_text;
      }
      return rtn;
    }

    const changeCorrectStateByDetail = (fieldActivity: FieldActivity, correct_state: number | null) => {
      context.emit("set-correct-by-child", fieldActivity, correct_state);
    }

    const initialize = () => {
      state.choice_idx_from = null;
      state.choice_idx_to = null;
      if(isSingleCharRecog){
        state.choices = Common.GetComboboxRecogCharArray(props.recog_type);
        const choice = state.choices.filter(x => x.text == props.recog_correct_text);
        state.correct_idx = choice.length == 1 ? choice[0].value : null;
        state.choice_idx_from = null;
        state.choice_idx_to = null;
      }
      updateCorrectSvgContent();
      state.errors = [];
      props.fieldActivities.forEach(x => recogTextChanged(x.id, x.recog_text));
    }

    const recogCancel = () => {
      context.emit("recog-cancel");
    }

    /************************************************************
      * mounted
      ************************************************************/
    
    onMounted(async () => {
      
    });

    return {
      ...toRefs(state),
      RecogTypeEnum,
      CorrectStateEnum,
      SheetTypeEnum,
      correctImageStyle,
      isSingleCharRecog,
      isDispFromToCharArea,
      hiddenSidebar,
      recogTypeChanged,
      recogExecute,
      recogByText,
      setResultFieldActivities,
      changeCorrectStateByDetail,
      initialize,
      correctTextChanged,
      recogTextChanged,
      recogCancel,
    }
  }
});
